import Heading from './Heading'
export default Heading
export type { IHeading } from './Heading.types'
